export default "__VITE_ASSET__BF_rEx_b__";